<template>
  <su-page>
    <el-row class="mt30" slot="content">
      <div v-if="citiesList && citiesList.length > 0">
        <div class="mb20">
          <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange">
            全选
          </el-checkbox>
          <el-button
              class="ml20"
              type="primary"
              size="small"
              :loading="loading"
              :disabled="loading"
              @click="deleteCollect">
            删除
          </el-button>
        </div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <div v-for="(city, index) in citiesList" :key="index">
            <el-checkbox :label="city.id">
              <div class="flex al-cn cl333 f14 mb15" style="white-space: normal; word-wrap: break-word;">
                {{ city.new.title }}
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <el-empty v-else :image-size="100" description="暂无收藏"></el-empty>
    </el-row>
  </su-page>
</template>
<script>

import {collect, delfavorite} from "@/api/api";

export default {
  name: "myCollection",
  data() {
    return {
      checkAll: false,
      checkedCities: [], // 选中的
      cityOptions: [], // 全部
      citiesList: [], // 收藏列表
      isIndeterminate: true,
      loading: false,
    }
  },
  created() {

  },
  mounted() {
    this.collect()
  },
  methods: {
    // 收藏列表
    collect() {
      collect().then(res => {
        if (res.status === 200) {
          this.citiesList = res.data.data
          this.cityOptions = res.data.data.map(item => {
            return item.id
          })
        }
      })
    },
    // 删除收藏
    deleteCollect() {
      if (this.checkedCities.length === 0) {
        this.$message.warning('请选择要删除的数据');
        return
      }
      //数组转字符串
      this.checkedCities = this.checkedCities.join(',')
      this.loading = true;
      delfavorite({collect_ids: this.checkedCities}).then(res => {
        this.loading = false;
        if (res.status === 200) {
          this.$message.success('删除成功');
          this.collect()
        }
      })
    },
    // 全选
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cityOptions : [];
      this.isIndeterminate = false;
    },
    // 单选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.citiesList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.citiesList.length;
    }
  }
}
</script>


<style lang="scss">

</style>
